import { AbstractEntity } from '../abstract-entity/abstract-entity';
import {
  Any,
  JsonConverter,
  JsonCustomConvert,
  JsonObject,
  JsonProperty
  } from 'json2typescript';
import { Archive } from './archive';
import { FieldType } from './field-type.enum';
import { Media } from '../../model/media/media';
import { MediaType } from '../../../src/model/media/media-type.enum';


@JsonConverter
export class ContentConverter implements JsonCustomConvert<any> {
  serialize(content: any) {
    for (let key in content) {
      if (content[key] instanceof Array) {
        let mediaKeys = content[key].filter((media: Media) => !!media.key).map((media: Media) => media.key);
        content[key] = mediaKeys.join('&&&');
      }
    }
    return content;
  }

  deserialize(content: any) {
    return content;
  }
}

@JsonObject
export class ArchiveRec extends AbstractEntity {
  @JsonProperty('archiveId', Number, true)
  archiveId: number = undefined;

  @JsonProperty('learnCertId', Any, true)
  learnCertId: number = undefined;

  @JsonProperty('userId', Number, true)
  userId: number = undefined;

  @JsonProperty('createAccountId', Number, true)
  createAccountId: number = undefined;

  @JsonProperty('modifyAccountId', Number, true)
  modifyAccountId: number = undefined;

  @JsonProperty('content', ContentConverter, true)
  content: any = undefined;

  @JsonProperty('categoryRec', Any, true)
  categoryRec: any = undefined;

  /**
   * è·åå°æ¡£æ¡è®°å½åéè¦åå§åæå¾ççå­æ®µ
   */
  initImageField(archive: Archive) {
    for (let key in this.content) {
      if (archive.getFieldByFieldId(Number(key))
        && archive.getFieldByFieldId(Number(key)).type === FieldType.ATTACHMENT) {
        let medias = [];
        this.content[key].split('&&&').forEach(mediaKey => {
          if (mediaKey) {
            medias.push(new Media(MediaType.IMAGE, mediaKey));
          }
        });
        this.content[key] = medias;
      }
    }
  }

}
